module.exports = __webpack_public_path__ + "img/T2C_rc_15.b658c100.png";